import React, { useContext } from "react";

import constant from "lib/constant/constant";

import { SkeletonAnnotated } from "lib/components";
import { PrivateContext } from "lib/context";

import { storageHelper } from "lib/helpers";

import { AdminPaymentExportSetting } from "app/payments/modules/admin/features";
import { OperatorPaymentExportSetting } from "app/payments/modules/operator/features";
import { ProviderPaymentExportSetting } from "app/payments/modules/provider/features";

const { userKey } = constant;
const { admin, operator, provider } = userKey;

const PaymentExportSetting = () => {
  const { isLoading } = useContext(PrivateContext);
  const getComponent = (role) => {
    if (isLoading) {
      return <SkeletonAnnotated />;
    }
    if (role === admin) {
      return <AdminPaymentExportSetting />;
    }
    if (role === operator) {
      return <OperatorPaymentExportSetting />;
    }
    if (role === provider) {
      return <ProviderPaymentExportSetting />;
    }
    return null;
  };

  const currentUserRole = storageHelper.get("userRole");
  const PaymentExportSettingComponent = getComponent(currentUserRole);
  return PaymentExportSettingComponent;
};

export default PaymentExportSetting;
